// extracted by mini-css-extract-plugin
module.exports = {"PlainFeature":"vu_a bha_b"};